
export default {
  gray: '#CCC',
  softGray: '#F8F8F8',
  white: 'white',
  borderColor: '#DDD',
  blue: '#4286F3',
};